import React from "react";
import styled from "@emotion/styled";

import InfosTooltip from "components/InfosTooltip";
import ParkkiTheme from "themes/ParkkiTheme";
import { DownloadGraph } from "./DownloadGraph";

const Container = styled.div`
  margin: 16px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const Title = styled.div`
  font-size: ${ParkkiTheme.fontSizes.small};
  font-weight: bolder;
  margin-top: ${ParkkiTheme.spacings.tiny};
  margin-bottom: ${(props: { withSubtitle: boolean }) =>
    props.withSubtitle ? "0px" : ParkkiTheme.spacings.xsmall};
`;

const Subtitle = styled.div`
  font-size: ${ParkkiTheme.fontSizes.xsmall};
  margin-top: ${ParkkiTheme.spacings.teeny};
  margin-bottom: ${ParkkiTheme.spacings.xsmall};
  color: ${(props: { subtitleColor?: string }) =>
    props.subtitleColor || "default"};
`;

type Props = {
  className?: string;
  title?: string;
  subtitle?: string | React.ReactNode;
  subtitleColor?: string;
  infoTooltip?: string;
  children: React.ReactNode;
  isAwol?: boolean;
  awolMessage?: string;
  style?: React.CSSProperties;
  withoutTitle?: boolean;
};

function Section({
  className,
  title,
  subtitle,
  children,
  subtitleColor,
  infoTooltip,
  isAwol = false,
  awolMessage,
  style,
  withoutTitle = false,
}: Props): JSX.Element {
  return (
    <Container style={style} className={className}>
      {!withoutTitle && (
        <TitleContainer>
          <Title withSubtitle={!!subtitle}>
            {title?.toUpperCase()}
            {isAwol &&
              awolMessage !== undefined &&
              awolMessage.length > 0 &&
              ` - ${awolMessage}`}
          </Title>
          {infoTooltip ? <InfosTooltip infos={infoTooltip} /> : null}

          <DownloadGraph title={title} />
        </TitleContainer>
      )}

      {!!subtitle ? (
        <Subtitle subtitleColor={subtitleColor}>{subtitle}</Subtitle>
      ) : null}
      {children}
    </Container>
  );
}

export default Section;
